<template lang="html">
    <div class="flex-col diagnosticList-container">
        <div class="breadCrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>{{$t('message.diagnostic')}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="flex-row second-tip">
            <div class="title"></div>
            <div class="flex-row search-container">
                <el-input :placeholder="$t('message.enterSN')" class="diagnostic-search" v-model="searchInput"  @keyup.enter.native="searchDiagnostic" clearable></el-input>
                <el-button class="search-btn" icon="el-icon-search" @click="searchDiagnostic"></el-button>
            </div>
        </div>
    <div class="diagnostic-table verifone-panel">
        <div class="appManagement-table-main">
            <template>
                <el-table :data="tableData" style="width: 100%" tooltip-effect="dark">
                    <el-table-column  prop="sn"  label="SN" width="200">
                        <template slot-scope="scope">
                            <router-link :to="{path:'/diagnosticDetial/',query:{id:scope.row.id}}"><a class="snName">{{ scope.row.sn }}</a></router-link>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="model" :label="$t('message.model')" show-overflow-tooltip></el-table-column>
                    <el-table-column  prop="romVersion" :label="$t('message.rom')" show-overflow-tooltip></el-table-column>
                    <el-table-column  prop="k21Version" :label="$t('message.k21')" show-overflow-tooltip></el-table-column>
                    <el-table-column  prop="date" :label="$t('message.LastDate')" show-overflow-tooltip></el-table-column>
                </el-table>
            </template>

            <div class="pagination-main">
                <el-pagination @current-change="refreshList"
                background layout="prev, pager, next"
                :current-page="pageNum"
                :page-count="pageCount">
            </el-pagination>
        </div>
    </div>
</div>
</div>
</template>

<script>
export default {
    data() {
        return {
            pageNum :1,
            pageCount:1,
            deleteAppId :'',
            searchInput:'',
            searchHistory: '',
            deleteTipVisible : false,
            researchType:0,//0 为查询分页查询APP 1搜索APP
            tableData: []
        }
    },
    mounted() {
        this.queryDiagnosticList();
    },
    methods: {
        // handlePage(val) {
        //     this.pageNum = val;
        //     this.refreshList();
        // },
        refreshList(val){
            this.pageNum = val;
            if(!this.searchInput) {
                this.queryDiagnosticList();
            }else {
                this.searchDiagnostic();
            }
        },
        queryDiagnosticList() {
            let that = this,
                obj = {
                    pageNum: this.pageNum
                };

            this.$axios({
                method: 'post',
                url: '/marketplace/diagnostic/page',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.researchType = 0;
                    that.pageCount = response.data.totalPage;
                    that.tableData = response.data.diagnostics;
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        searchDiagnostic() {
            let that = this,
                obj = {
                    sn:this.searchInput,
                    pageNum:1
                };

                if(this.searchInput == '') {
    				this.pageNum = 1;
    				this.searchHistory = '';
    				this.queryDiagnosticList();
    				return;
    			}

    			//new query => refresh page
    			if(this.searchInput != this.searchHistory) {
    				this.pageNum = 1;
    			}else {
    				obj.pageNum = this.pageNum;
    			}

            this.$axios({
                method: 'post',
                url: '/marketplace/diagnostic/query',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.researchType = 1;
                    that.tableData = response.data.diagnostics;
                    that.pageCount = response.data.totalPage;
                    that.searchHistory = that.searchInput;
                }
            }).catch((err) => {
                console.log(err);
            });
        },
      handleCurrentChange(val) {
        console.log("val"+val);
        this.pageNum = val;
        this.refreshList();
      },

    }
}
</script>

<style lang="css" scope="scoped">
.snName {
    color: #3ba2ec;
    text-decoration:underline;
}
.appManagement-table-main {
    padding: 20px;
    background-color: #fff;
}
.pagination-main {
    padding:30px 0 10px;
    background: #fff;
    width: 100%;
}
.diagnostic-search {
    margin-right: 10px;
    width: 400px;
}
/* .el-input {
width: 400px;
} */
</style>



// WEBPACK FOOTER //
// src/components/page/DiagnosticList.vue